<template>
    <div class="page main-background">
        <div v-if="!loading">
            <div class="error-message" v-if="errorMessage">
                <h3 class="loading-title text-color">{{errorMessage}}</h3>
            </div>
            <div v-if="!errorMessage && airPollutions">

                <h2 class="page-title text-color">نتیجه استعلام روزهای مجاز باقی مانده طرح کاهش آلودگی هوای تهران</h2>

                <div class="text-color border-color background-color card">
                    <div class="header-item">

                        <div class="header-item-value">
                            <div class="plate">
                                <img class="img-plate" alt="پلاک" title="پلاک"
                                    src="../../assets/img/img_empty_plate.png" />
                                <div class="two-digit">
                                    {{airPollutions.PlateNo.toString().substr(0, 2) | persian}}
                                </div>
                                <div class="plate-alphabet">
                                    <div v-if="airPollutions.PlateNo.toString().substr(2, 2)==='01'">الف</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='02'">ب</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='03'">پ</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='04'">ت</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='05'">ث</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='06'">ج</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='07'">چ</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='08'">ح</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='09'">خ</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='10'">د</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='11'">ذ</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='12'">ر</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='13'">ز</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='14'">ژ</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='15'">س</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='16'">ش</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='17'">ص</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='18'">ض</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='19'">ط</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='20'">ظ</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='21'">ع</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='22'">غ</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='23'">ف</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='24'">ق</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='25'">ک</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='26'">گ</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='27'">ل</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='28'">م</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='29'">ن</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='30'">و</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='31'">ه</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='32'">ی</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='33'">معلولین</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='34'">تشریفات</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='51'">A</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='52'">B</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='53'">C</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='54'">D</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='55'">E</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='56'">F</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='57'">G</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='58'">H</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='59'">I</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='60'">J</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='61'">K</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='62'">L</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='63'">M</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='64'">N</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='65'">O</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='66'">P</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='67'">Q</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='68'">R</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='69'">S</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='70'">T</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='71'">U</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='72'">V</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='73'">W</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='74'">X</div>
                                    <div v-else-if="airPollutions.PlateNo.toString().substr(2, 2)==='75'">Y</div>

                                </div>
                                <div class="three-digit">
                                    {{airPollutions.PlateNo.toString().substr(4, 3) | persian}}
                                </div>
                                <div class="iran-digit">
                                    {{airPollutions.PlateNo.toString().substr(7, 2) | persian}}
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <div v-for="item in airPollutions.Seasons" :key="item.EntryDaysCount">
                    <div class="detail-item text-color border-color background-color">
                        <div class="detail-item-header">
                            <div>
                                <h1 v-if="item.Season===1">بهار سال {{item.Year | persian}}</h1>
                                <h1 v-else-if="item.Season===2">تابستان سال {{item.Year | persian}}</h1>
                                <h1 v-else-if="item.Season===3">پاییز سال {{item.Year | persian}}</h1>
                                <h1 v-else-if="item.Season===4">زمستان سال {{item.Year | persian}}</h1>
                            </div>


                        </div>
                        <div class="detail-item-body">
                            <div>
                                تعداد تردد: {{item.EntryDaysCount | separator | persian}} روز
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div v-if="loading">
            <h3 class="loading-title text-color">در حال دریافت اطلاعات روزهای مجاز باقی مانده طرح کاهش آلودگی هوای تهران
                برای خودروی شما، لطفا شکیبا باشید.</h3>
            <loader />
        </div>
    </div>
</template>

<script>
import api, { BaseUrl } from '../../service';
import loader from '../../components/inquiry/Loader';
import { mapGetters } from 'vuex';

export default {
    name: "air-pollutions",
    components: {
        loader
    },
    props: {
        carId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            errorMessage: null,
            loading: false,
            airPollutions: null,
            baseUrl: BaseUrl
        };
    },
    mounted() {
        this.loading = true;
        api.getAirPollutions(this.carId).then((response) => {
            if (response.data && response.data.Status === 200) {
                this.airPollutions = response.data.Data;
            } else {
                if (response.data && response.data.Messages && response.data.Messages.length > 0) {
                    this.errorMessage = response.data.Messages[0];
                }
            }
        }).catch(() => {
            this.errorMessage = "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
        }).finally(() => {
            this.loading = false;
        });
    },
    computed: {
        ...mapGetters(["getToken"])
    }
}
</script>

<style scoped>
.page {
    padding-bottom: 20px;
    display: flow-root;
}

.page-title {
    padding: 20px 12px 8px 12px;
}

.card {
    border: solid 1px;
    margin: 10px 10px 0 10px;
    border-radius: 5px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    border-bottom: solid 3px #09389f !important;
    position: relative;
}

.detail-item {
    border: solid 1px;
    margin: 10px 10px 0 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    line-height: 27px;
}

.detail-item-header {
    background-color: #09389f;
    padding: 4px 12px;
    color: white;
}

.detail-item-body {
    padding: 8px 12px;
}

.loading-title {
    padding: 50px 15px 0;
    text-align: center;
}

.header-item {
    display: flex;
    line-height: 40px;
}

.header-item-title {
    flex: 1;
}

.payment-button {
    border: solid 1px #00c11b;
    background-color: #00c11b;
    padding: 4px 20px;
    color: white;
    border-radius: 5px;
    margin: 10px 8px;
}
</style>
<style scoped>
.card {
    border: solid 1px;
    margin: 7px 10px 0 10px;
    border-radius: 5px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    border-bottom: solid 1px;
    position: relative;
    text-align: center;
}

.card h3 {
    margin-bottom: 4px;
}

.plate {
    width: 230px;
    display: inline-block;
    margin: auto;
    position: relative;
}

.img-plate {
    width: 100%;
}

.plate .two-digit {
    font-family: nazanin;
    font-weight: bold;
    font-size: 30px;
    position: absolute;
    top: 15px;
    right: 157px;
    width: 50px;
    color: #555;
}

.plate .plate-alphabet {
    font-family: nazanin;
    font-weight: bold;
    font-size: 30px;
    position: absolute;
    top: 15px;
    right: 120px;
    width: 46px;
    color: #555;
}

.plate .three-digit {
    font-family: nazanin;
    font-weight: bold;
    font-size: 30px;
    position: absolute;
    top: 15px;
    right: 60px;
    width: 60px;
    color: #555;
}

.plate .iran-digit {
    font-family: nazanin;
    font-weight: bold;
    font-size: 27px;
    position: absolute;
    top: 18px;
    right: 6px;
    width: 45px;
    color: #555;
}

.opacity {
    opacity: 0.5;
}
</style>
